import { TableCollection as AriaTableCollection } from './TableCollection_COPIED';
import React from 'react';
import { CollectionNode } from 'react-aria/private/collections/BaseCollection';

type Mutable<T> = {
  -readonly [P in keyof T]: T[P];
};

export class TableFooterNode<T> extends CollectionNode<T> {
  static readonly type = 'tablefooter';
}

const nullFooter = new TableFooterNode<any>(-3);

export class SapphireTableCollection<T> extends AriaTableCollection<T> {
  footer: CollectionNode<T> = nullFooter;

  addNode(node: CollectionNode<T>): void {
    if (node.type === 'cell' && node.props.colSpan === 'remaining') {
      (node as Mutable<CollectionNode<T>>).colSpan =
        [...this.getChildren(this.head.key)].length - (node.colIndex ?? 0);
    }
    super.addNode(node);

    if (node.type === 'tablefooter') {
      this.footer = node;
    }
  }

  *[Symbol.iterator]() {
    yield* super[Symbol.iterator]();
    if (this.footer !== nullFooter) {
      yield this.footer;
    }
  }

  getLastKey(): React.Key | null {
    return this.footer.lastChildKey ?? super.getLastKey();
  }

  clone(): this {
    const collection = super.clone();
    collection.footer = this.footer;
    return collection;
  }

  commit(
    firstKey: React.Key,
    lastKey: React.Key,
    isSSR: boolean = false
  ): void {
    this.patchMissingRowHeaderColumn();
    super.commit(firstKey, lastKey, isSSR);
    // this.rows.push(...this.getChildren(this.footer.key));
  }

  /**
   * TODO(v6): remove this, which will make it required for at least one column to be
   *   marked as rowHeader. Add isRowHeader to all test cases and examples
   */
  private patchMissingRowHeaderColumn() {
    const columns = [...this.getChildren(this.head.key)].filter(
      (node) => node.type === 'column'
    );
    if (!columns.some((column) => column.props.isRowHeader) && columns[0]) {
      // eslint-disable-next-line no-console
      console.warn(
        'Sapphire deprecation warning: at least one of the columns in InteractiveTable must have isRowHeader. The first column is marked as row header. This will throw an error in v6'
      );
      columns[0].props.isRowHeader = true; // TODO(v6)
    }
  }
}
